/**
 * Created by Vaibhav on 20-06-2017.
 */

import { Injectable } from "@angular/core";
import { HttpClientService } from "../../common/http-client.service";
import { Subject } from "rxjs/Subject";
import {
  Http,
  Headers,
  RequestOptions,
  ResponseContentType,
} from "@angular/http";

import { CommonService } from "../../common/common.service";

@Injectable()
export class UserGroupManagementService {
  userId: string;
  constructor(private http: HttpClientService, private common: CommonService) {
    // this.userId = this.common.getUserInfo().userId;
    this.userId = this.common.getUserInfo()["userName"];
    // console.log(this.userId);
    // this.filterConditionsList();
  }

  checkUserGroupNameDuplicate(obj): any {
    return this.http.post(`name/validate`, obj, 4);
  }
  getEntityTypeList(): any {
    return this.http.get("getEntityType/0", null, 5);
  }
  getUserGroupList(): any {
    return this.http.get("list", null, 4);
  }
  getUserGroupHistoryList(id): any {
    return this.http.get("" + id + "/history", null, 4);
  }
  getUserGroupASGDetails(serviceGroupId): any {
    return this.http.get(`serviceGroupInfo/${serviceGroupId}`, null, 10);
  }
  getUserGroupASGServiceList(serviceGroupId): any {
    return this.http.get(`viewServiceGroup/${serviceGroupId}`, null, 10);
  }
  getUserGroupDetails(userGroupId) {
    return this.http.get(`list/${userGroupId}`, null, 4);
  }
  getUserGroupAllUserList(id): any {
    return this.http.get("" + id + "/users", null, 4);
  }
  getUserGroupSchedule(id): any {
    return this.http.get("" + id + "/schedule", null, 4);
  }
  updateUserGroupSchedule(obj): any {
    obj["userId"] = this.userId;
    return this.http.post("schedule/save", obj, 4);
  }
  updateUserGroupStatus(obj): any {
    obj["userId"] = this.userId;
    return this.http.post("update/status", obj, 4);
  }
  getUserGroupFilterList(typeId) {
    return this.http.get(`${typeId}/filters`, null, 4);
    //        return this.http.get('getUserGroupFilterList', 4);
  }
  getUserGroupFilterCondition(filterId) {
    return this.http.get(`filter/${filterId}/conditions`, null, 4);
  }
  getUserGroupFilterCombinationList(obj) {
    return this.http.get("getUserGroupFilterCombinationList", obj, 4);
  }
  getServiceGroupList() {
    return this.http.get("all", null, 10);
  }
  attachServiceGroup(obj) {
    obj["userId"] = this.userId;
    return this.http.post("attach/serviceGroup", obj, 4);
    //   return this.http.post('servicegroup/save',obj, 4);
  }
  getAttachedSG(userGroupId) {
    return this.http.get(`${userGroupId}/servicegroup`, null, 4);
  }
  getUserGroupFilterStringList(filterId, parentId = 0) {
    return this.http.get(`filter/${filterId}/${parentId}/list`, null, 4);
  }
  saveUserGroup(obj) {
    return this.http.post("save", obj, 4);
  }

  updateUserGroup(obj) {
    obj["modifyBy"] = this.userId;
    obj["userId"] = this.userId;
    return this.http.post("update", obj, 4);
  }

  saveUserGroupFileUpload(obj) {
    return this.http.postFile("upload", obj, 10);
  }
  deleteUserGroupFilter(obj) {
    return this.http.post(`filter/remove`, obj, 4);
  }
  renameUserGroup(obj) {
    obj["userId"] = this.userId;
    return this.http.post(`update/name`, obj, 4);
  }
  deleteUserGroup(obj) {
    obj["userId"] = this.userId;
    return this.http.post(`remove`, obj, 4);
  }
  saveUserGroupPromocodes(obj) {
    obj["userId"] = this.userId;
    return this.http.post(`update/promocode`, obj, 4);
  }
  getUserGroupPromocodesList(userGroupId) {
    // userGroupId = 0 for all promocodes
    return this.http.get(`${userGroupId}/promocode/list`, null, 4);
  }
  getUserGroupOverride(userGroupId) {
    return this.http.get(`${userGroupId}/override`, null, 4);
  }
  updateUserGroupOverride(obj) {
    obj["userId"] = this.userId;
    return this.http.post(`update/override`, obj, 4);
  }
  downloadSuccessFulUserListFile(userGroupId, fileExtension) {
    return this.http.get(
      `${userGroupId}/upload/users/download`,
      null,
      4,
      null,
      "blob",
      fileExtension,
      { responseType: ResponseContentType.Blob }
    );
  }
  downloadUserGroupSampleFile(fileExtension) {
    return this.http.get(
      "template/download?fileName=BulkWalletCreationTemplate." + fileExtension,
      null,
      0,
      null,
      "blob",
      fileExtension,
      { responseType: ResponseContentType.Blob }
    );
  }
  downloadUserListFile(userGroupId, fileExtension) {
    let headObj: any = {
      Authorization: localStorage.getItem("tkn"),
    };
    let headers = new Headers(headObj);
    return this.http.get(
      `${userGroupId}/users/download`,
      null,
      4,
      null,
      "blob",
      fileExtension,
      { responseType: ResponseContentType.Blob }
    );
  }

  getSubEntityTypeList(entityId) {
    return this.http.get(`getEntitySubType/${entityId}`, null, 5);
  }

  getSegmentList() {
    return this.http.get(`getSegmentList`, null, 5);
  }

  getSurroundSystemList() {
    return this.http.get(`getSurroundSystem`, null, 5);
  }

  private fetchFilterCounter = new Subject<string>();
  fetchFilterCountered$ = this.fetchFilterCounter.asObservable();

  filterConditionCount = 0;
  getFilterConditionCount() {
    return this.filterConditionCount;
  }
  filterConditionsList() {
    for (var x in this.filterTypes) {
      this.callGetFilterConditionsList(x);
    }
  }

  callGetFilterConditionsList(x) {
    this.getUserGroupFilterCondition(x).subscribe(
      (data) => {
        if (data.status == "success") {
          if (data.object) {
            this[this.filterTypes[x] + "Condition"] = data.object;
            ++this.filterConditionCount;
            this.fetchFilterCounter.next();
          } else {
          }
        } else {
        }
      },
      (err) => {}
    );
  }

  userGroupTypes = [
    {
      id: 1,
      name: "Primary User Group",
    },
    {
      id: 2,
      name: "Offline User Group",
    },
  ];
  filterTypes = {
    "1": "string",
    "2": "number",
    "3": "date",
    "4": "entity",
    "5": "mobile",
    "6": "include",
    "7": "exclude",
    "8": "dateRange",
    "9": "transRange",
  };

  channelTypes = [
    {
      id: 21,
      name: "USSD",
    },
    {
      id: 22,
      name: "WEB",
    },
    {
      id: 23,
      name: "APP",
    },
  ];

  downloadUserListExcelFilePath(userGroupId) {
    return (
      this.http.MFS_USER_GROUP_API_ENDPOINT + `${userGroupId}/users/download`
    );
  }
  downloadUserGroupFilterExcelFilePath() {
    return this.http.MFS_USER_GROUP_API_ENDPOINT + `users/sample/download`;
  }
  addPrefixZero(r) {
    return String(r).length == 1 ? "0" + r : r;
  }
  removePrefixZero(r) {
    if (String(r || "").length > 1) {
      if (String(r || "").startsWith("0")) {
        r = r.slice(1);
      }
    }
    return r;
  }
  dateFormatChanger(date, delimiter = "/") {
    return (
      this.addPrefixZero(date.day) +
      delimiter +
      this.addPrefixZero(date.month) +
      delimiter +
      this.addPrefixZero(date.year)
    );
  }
  dateObjFormat(AdditionalDayCount: number) {
    var todayDate: Date = new Date();
    todayDate.setDate(todayDate.getDate() + AdditionalDayCount);
    var dateObj = {
      year: todayDate.getFullYear(),
      month: todayDate.getMonth() + 1,
      day: todayDate.getDate(),
    };
    return dateObj;
  }
  dateDeFormatChanger(date) {
    if (date == null || date == "") return date;
    var f: any = {};
    if (date.indexOf("-") != -1) {
      var d = date.split("-");
      console.log(date, d);
      f.day = this.removePrefixZero(d[0]);
      f.month = this.removePrefixZero(d[1]);
      f.year = this.removePrefixZero(d[2]);
    } else if (date.indexOf("/") != -1) {
      var d = date.split("/");
      f.day = this.removePrefixZero(d[0]);
      f.month = this.removePrefixZero(d[1]);
      f.year = this.removePrefixZero(d[2]);
    }
    return f;
  }
  dateDeFormatChangerNew(date) {
    if (date == null || date == "") return date;
    if (date.indexOf("T") > -1) date = date.split("T")[0];

    var f: any = {};
    if (date.indexOf("-") != -1) {
      var d = date.split("-");
      f.year = this.removePrefixZero(d[0]);
      f.month = this.removePrefixZero(d[1]);
      f.day = this.removePrefixZero(d[2]);
    } else if (date.indexOf("/") != -1) {
      var d = date.split("/");
      f.year = this.removePrefixZero(d[0]);
      f.month = this.removePrefixZero(d[1]);
      f.day = this.removePrefixZero(d[2]);
    }
    return f;
  }
  formattingFilterData(array) {
    var a: any = [];
    var i = 0;
    a[i] = [array[0].data];
    for (var index = 1; index < array.length; index++) {
      if (array[index].opr == "OR") {
        if (!Array.isArray(a[i])) {
          var temp = a[i];
          a[i] = [];
          a[i].push(temp);
          a[i].push(array[index].data);
        } else {
          a[i].push(array[index].data);
        }
      } else {
        ++i;
        a[i] = [array[index].data];
      }
    }
    return a;
  }
  deFormattingFilterData(array) {
    var a: any = [];
    array.forEach((x, i) => {
      var firstCheck = false;
      if (i != 0) {
        if (Array.isArray(array[i - 1])) {
          firstCheck = true;
        }
      }
      if (Array.isArray(x)) {
        for (var y of x) {
          a.push(
            new filter(y, a.length == 0 ? "AND" : firstCheck ? "AND" : "OR")
          );
          firstCheck = false;
        }
      } else {
        a.push(new filter(x, "AND"));
      }
    });
    return a;
  }

  _entityCondition = entityCondition;
  _stringCondition = stringCondition;
  _numberCondition = numberCondition;
  _dateCondition = dateCondition;
  _mobileCondition = mobileCondition;
  _includeCondition = includeCondition;
  _excludeCondition = excludeCondition;
  _dateRangeCondition = dateRangeCondition;
  _transRangeCondition = transRangeCondition;

  get entityCondition(): any {
    return this._entityCondition;
  }
  set entityCondition(s) {
    this._entityCondition = s;
  }
  get stringCondition(): any {
    return this._stringCondition;
  }
  set stringCondition(s) {
    this._stringCondition = s;
  }
  get numberCondition(): any {
    return this._numberCondition;
  }
  set numberCondition(s) {
    this._numberCondition = s;
  }
  get dateCondition(): any {
    return this._dateCondition;
  }
  set dateCondition(s) {
    this._dateCondition = s;
  }
  get mobileCondition(): any {
    return this._mobileCondition;
  }
  set mobileCondition(s) {
    this._mobileCondition = s;
  }
  get dateRangeCondition() {
    return this._dateRangeCondition;
  }
  set dateRangeCondition(s) {
    this._dateRangeCondition = s;
  }
  get transRangeCondition() {
    return this._transRangeCondition;
  }
  set transRangeCondition(s) {
    this._transRangeCondition = s;
  }
  get includeCondition() {
    return this._includeCondition;
  }
  set includeCondition(s) {
    this._includeCondition = s;
  }
  get excludeCondition() {
    return this._excludeCondition;
  }
  set excludeCondition(s) {
    this._excludeCondition = s;
  }

  filter(data, opr) {
    return new filter(data, opr);
  }
  filterAttr(type, name, filterId, conditions?: any) {
    if (type == 4)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.entityCondition
      );
    else if (type == 1)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.stringCondition
      );
    else if (type == 2)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.numberCondition
      );
    else if (type == 3)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.dateCondition
      );
    else if (type == 5)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.mobileCondition
      );
    else if (type == 6)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.includeCondition
      );
    else if (type == 7)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.excludeCondition
      );
    else if (type == 8)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.dateRangeCondition
      );
    else if (type == 9)
      return new filterAttr(
        type,
        name,
        filterId,
        conditions || this.transRangeCondition
      );
  }
}

var filter = function (data, opr) {
  this.opr = opr || "AND";
  this.data = data;
};
var filterAttr = function (type, name, filterId, conditions?: any) {
  this.id = 0;
  this.type = type;
  this.filterId = filterId;
  this.filterName = name;
  this.conditionId = "";
  this.value = "";
  if (32 >= this.filterId && this.filterId >= 27) {
    this.conditionId = 1;
  }
  if (type == "4") {
    this.conditions = conditions || entityCondition;
    this.conditionId = 15;
  } else if (type == "1") {
    this.conditions = conditions || stringCondition;
  } else if (type == "2") {
    this.conditions = conditions || numberCondition;
  } else if (type == "3") {
    this.conditions = conditions || dateCondition;
  } else if (type == "5") {
    this.conditions = conditions || mobileCondition;
  } else if (type == "6") {
    this.conditions = conditions || includeCondition;
    this.conditionId = 18;
  } else if (type == "7") {
    this.conditions = conditions || excludeCondition;
    this.conditionId = 19;
  } else if (type == "8") {
    this.conditionId = 17;
    this.conditions = conditions || dateRangeCondition;
  } else if (type == "9") {
    this.conditions = conditions || transRangeCondition;
  }
};
const stringCondition = null;
const numberCondition = null;
const dateCondition = null;
const entityCondition = null;
const mobileCondition = null;
const includeCondition = null;
const excludeCondition = null;
const dateRangeCondition = null;
const transRangeCondition = null;



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/main/user-group-management/user-group-management.service.ts